// Currency utility for Indonesian Rupiah formatting
export const formatCurrency = (amount) => {
  return `Rp ${(amount || 0).toLocaleString('id-ID')}`;
};

// Format number with thousand separators (Indonesian style: 3.000.000)
export const formatNumber = (value) => {
  if (!value && value !== 0) return '';
  return Number(value).toLocaleString('id-ID');
};

// Parse formatted number back to raw number
export const parseFormattedNumber = (formatted) => {
  if (!formatted) return 0;
  return Number(String(formatted).replace(/\./g, '').replace(/,/g, '')) || 0;
};
